import { FunctionComponent } from 'react';

import { LinkProps, To } from 'react-router-dom';

import { Tab, TabProps } from '@cast/design-system';

import { Link } from 'components/router';

export type RoutedTabProps<Value extends string = string> = Omit<
  TabProps<Value, FunctionComponent<LinkProps>>,
  'to'
> & {
  to?: To;
};

export const RoutedTab = <Value extends string = string>({
  to,
  ...props
}: RoutedTabProps<Value>) => {
  return <Tab to={to} component={Link} replace {...props} />;
};
